import { isCypressEnv } from '@clef/client-library/src/utils/env';

const isCypress = isCypressEnv();

export const pendoEntity = typeof pendo !== 'undefined' && !isCypress ? pendo : undefined;
